"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.totaledInterestPaymentsSelector = exports.totalInterestPaymentsSelector = exports.interestPaymentsSelector = exports.filteredInterestPaymentsSelector = void 0;
var _reselect = require("reselect");
var _reduxForm = require("redux-form");
var _get = _interopRequireDefault(require("lodash/get"));
var _productPositionSelectors = require("./productPositionSelectors");
var _activityFilters = require("../../helpers/activityFilters");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var interestPaymentsSelector = exports.interestPaymentsSelector = (0, _reselect.createSelector)([function (state) {
  return state.interestBearingAccounts.interestPayments;
}, _productPositionSelectors.productPositionAssetsSelector], function (payments, productPositionAssets) {
  if (!Array.isArray(payments)) {
    return [];
  }
  return payments.map(function (i) {
    var productPos = productPositionAssets.find(function (j) {
      return j.ProductId === i.ProductId;
    });
    return _objectSpread(_objectSpread(_objectSpread({}, productPos), i), {}, {
      ConvertedCrAmount: (0, _get["default"])(productPos, 'NotionalRate', 0) * i.CR
    });
  });
});
var totalInterestPaymentsSelector = exports.totalInterestPaymentsSelector = (0, _reselect.createSelector)(interestPaymentsSelector, function (interestPayments) {
  return interestPayments.reduce(function (acc, i) {
    acc += i.ConvertedCrAmount;
    return acc;
  }, 0);
});
var totaledInterestPaymentsSelector = exports.totaledInterestPaymentsSelector = (0, _reselect.createSelector)(interestPaymentsSelector, function (payments) {
  return payments.reduce(function (acc, i) {
    if (!acc[i.ProductId]) acc[i.ProductId] = {};
    var now = new Date();
    var sevenDay = now.setDate(now.getDate() - 10);
    if (i.TimeStamp > sevenDay) {
      acc[i.ProductId]['7DayEarnings'] = (acc[i.ProductId]['7DayEarnings'] || 0) + i.CR;
    }
    acc[i.ProductId]['Total'] = (acc[i.ProductId]['Total'] || 0) + i.CR;
    return acc;
  }, {});
});
var filteredInterestPaymentsSelector = exports.filteredInterestPaymentsSelector = (0, _reselect.createSelector)([function (state) {
  return state;
}, interestPaymentsSelector], function (state, payments) {
  var formValue = (0, _reduxForm.formValueSelector)('interest-payments');
  var product = formValue(state, 'product');
  var startDate = formValue(state, 'startDate');
  var endDate = formValue(state, 'endDate');
  return payments.filter(function (i) {
    if (product && product !== 'all') {
      return i.ProductId === parseInt(product);
    }
    return true;
  }).filter(function (i) {
    return (0, _activityFilters.rawDateFilter)(i, startDate, endDate);
  });
});